import React, { useEffect } from 'react';
import Router from './router';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useCurrentPlan, useOrganization } from './context/organization';
import { setAnalyticsContext } from './analytics';
import { MembersProvider } from './context/members';
import { PricingPlansProvider } from './context/pricing-plans';
import { ApiKeyProvider } from './context/api-keys';
import { QueryMetadataProvider } from './context/query-metadata';

const App: React.FC = () => {
  const { user, isAuthenticated } = useAuth0();
  const navigate = useNavigate();
  const { loginUser, organization, accountLinked } = useOrganization();
  const { currentPlan } = useCurrentPlan();

  useEffect(() => {
    if (!user || !isAuthenticated) return;
  
    const path = window.location.pathname;
    const isJoinRoute = /^\/join\/[^/]+$/.test(path);
  
    const me = async () => {
      const data = await loginUser(user);
  
      const hasOrg = !!data.organization;
      const shouldRedirectToOrg =
        !hasOrg && path !== '/organization' && !isJoinRoute;
  
      if (shouldRedirectToOrg) {
        navigate('/organization');
      }
    };
  
    me();
  }, [user, isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) return;
    setAnalyticsContext({
      user: organization?.me ?? null,
      auth0User: { email: user?.email ?? null, name: user?.name ?? null, sub: user?.sub ?? null },
      organization,
      currentPlan,
      accountLinked,
    });
  }, [isAuthenticated, organization, user, currentPlan, accountLinked]);

  return (
    <QueryMetadataProvider>
      <ApiKeyProvider>
        <MembersProvider>
          <PricingPlansProvider>
            <Router />
          </PricingPlansProvider>
        </MembersProvider>
      </ApiKeyProvider>
    </QueryMetadataProvider>
  );
}

export default App;
